import { useDeleteSharedMissingPerson } from '../useDeleteSharedMissingPerson';
import { useSharedMissingPerson } from '../useSharedMissingPerson';
import { useUpsertSharedMissingPerson } from '../useUpsertSharedMissingPerson';
import { useMemo } from 'react';
import { SharedMissingPersonEditorDialog } from './SharedMissingPersonEditorDialog';

export function SharedMissingPersonEditor({ ids, isOpen, onClose }) {
  const defaultShare = useMemo(
    () => ({ personId: ids?.personId, groupCodes: [] }),
    [ids?.personId],
  );
  const {
    query: { data: fetchedShare },
  } = useSharedMissingPerson(ids?.personId);
  const share = fetchedShare ?? defaultShare;
  const { mutate: upsertMissingPerson } = useUpsertSharedMissingPerson();
  const { mutate: deleteMissingPerson } = useDeleteSharedMissingPerson();

  function handleClose(values) {
    if (values) {
      upsertMissingPerson(values);
    }

    onClose();
  }

  function handleDelete() {
    deleteMissingPerson(ids?.code);

    onClose();
  }

  return (
    <SharedMissingPersonEditorDialog
      key={share}
      share={share}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
    />
  );
}
